import type { HelpArticle } from '../../../components/help/types';

export const faqArticles: HelpArticle[] = [
  {
    id: 'faq-general',
    title: 'Frequently Asked Questions',
    summary: 'Answers to common questions about OHCS RMS.',
    category: 'faq',
    order: 1,
    keywords: ['faq', 'questions', 'answers', 'common', 'help'],
    content: `
# Frequently Asked Questions

Common questions and answers about OHCS RMS.

## General Questions

### What is OHCS RMS?
OHCS Records Management System is Ghana's platform for managing civil service documents, personnel files, and workflows.

### Who can use the system?
Staff members of Ministries, Departments, and Agencies (MDAs) across Ghana's civil service.

### How do I get access?
Contact your institution's IT administrator to request an account.

## Account Questions

### How do I reset my password?
1. Click "Forgot Password" on the login page
2. Enter your email address
3. Check your email for reset link
4. Create a new password

### Why can't I see certain documents?
Document access is controlled by:
- Your role and permissions
- Document classification level
- Department restrictions

### How do I change my email?
Contact your institution administrator to update account details.

## Technical Questions

### What browsers are supported?
- Chrome (recommended)
- Firefox
- Safari
- Edge

### Can I use the system on mobile?
Yes, the system works on mobile browsers and as an installable app.

### What if the system is slow?
1. Check your internet connection
2. Clear browser cache
3. Try a different browser
4. Report ongoing issues to IT

## Document Questions

### What file types can I upload?
PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, and more. Maximum file size is 50MB.

### Can I recover deleted documents?
Deleted documents go to Recycle Bin for 30 days. After that, contact IT for recovery.

### How do I share a document?
Use the Share feature to grant access to specific users or departments.
    `,
  },
];
